import { FC, memo } from "react";
import { useWindows } from "@/contexts/windows";
import { RD_WindowID_T } from "@/contexts/windows/types";
import StyledSnapOptions from "./StyledSnapOptions";
import StyledSnapLayout from "./StyledSnapLayout";
import StyledSnapper from "./StyledSnapper";

type SnapOptionsProps = {
  id: RD_WindowID_T;
  onFocus?: () => void;
  onUnfocus?: () => void;
};

const SnapOptions: FC<SnapOptionsProps> = ({ id, onFocus, onUnfocus }) => {
  const {
    windows: { [id]: currentWindow },
    setSnap,
  } = useWindows();
  return (
    <StyledSnapOptions
      onMouseEnter={onFocus}
      onMouseLeave={onUnfocus}
      onBlurCapture={onUnfocus}
    >
      <StyledSnapLayout>
        <StyledSnapper
          onClick={() => {
            setSnap(id, {
              type: "twoColumns",
              index: 0,
              widthPercent: 50
            });
          }}
        ></StyledSnapper>
        <StyledSnapper
          onClick={() => {
            setSnap(id, {
              type: "twoColumns",
              index: 1,
              widthPercent: 50,
            });
          }}
        ></StyledSnapper>
      </StyledSnapLayout>
    </StyledSnapOptions>
  );
};

export default memo(SnapOptions);
